<template>
  <div class="driver-create-form-wrapper">
    <BaseFormSection title="Основная информация">
      <BaseFormField
        label="Фамилия:"
        for-id="last_name"
        required
        :filled="isFieldFilled('last_name')"
        :error="errors.last_name"
        info-key="driver.common"
      >
        <base-input
          id="last_name"
          type="text"
          v-model="localFormData.last_name"
          class="form-input"
          :invalid="errors.last_name"
          @input="$emit('clear-error', 'last_name')"
        />
      </BaseFormField>

      <BaseFormField
        label="Имя:"
        for-id="first_name"
        required
        :filled="isFieldFilled('first_name')"
        :error="errors.first_name"
        info-key="driver.common"
      >
        <base-input
          id="first_name"
          type="text"
          v-model="localFormData.first_name"
          class="form-input"
          :invalid="errors.first_name"
          @input="$emit('clear-error', 'first_name')"
        />
      </BaseFormField>

      <BaseFormField
        label="Отчество:"
        for-id="middle_name"
        info-key="driver.common"
      >
        <base-input
          id="middle_name"
          type="text"
          v-model="localFormData.middle_name"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="ИНН:" for-id="inn" info-key="driver.common">
        <base-input
          id="inn"
          type="text"
          v-model="localFormData.inn"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Телефон:" for-id="phone" info-key="driver.common">
        <base-input
          id="phone"
          type="text"
          v-model="localFormData.phone"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Дата приёма:" for-id="employment_date">
        <base-input
          id="employment_date"
          type="date"
          v-model="localFormData.employment_date"
          class="form-input"
        />
      </BaseFormField>
    </BaseFormSection>

    <BaseFormSection title="Водительское удостоверение">
      <BaseFormField
        label="Серия ВУ:"
        for-id="license_series"
        info-key="driver.license"
      >
        <base-input
          id="license_series"
          type="text"
          v-model="localFormData.driver_license.series"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField
        label="Номер ВУ:"
        for-id="license_number"
        info-key="driver.license"
      >
        <base-input
          id="license_number"
          type="text"
          v-model="localFormData.driver_license.number"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Кем выдано:" for-id="license_issued_by">
        <base-input
          id="license_issued_by"
          type="text"
          v-model="localFormData.driver_license.issued_by"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField
        label="Дата выдачи ВУ:"
        for-id="license_issued_at"
        info-key="driver.license"
      >
        <base-input
          id="license_issued_at"
          type="date"
          v-model="localFormData.driver_license.issued_at"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Действует до:" for-id="license_valid_to">
        <base-input
          id="license_valid_to"
          type="date"
          v-model="localFormData.driver_license.valid_to"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Категории:" for-id="license_categories" wide>
        <DriverLicenseCategories
          id="license_categories"
          v-model="localFormData.driver_license.categories"
          selectable
        />
      </BaseFormField>

      <BaseFormField label="Сканы ВУ:" for-id="license_attachments" wide>
        <AttachmentUploader
          v-model:attachment-ids="localFormData.driver_license.attachment_ids"
          attachable-type="DriverLicense"
          compact
          requisite-code="driver-license"
          :form-id="formId"
          :existing-attachments="localFormData.driver_license.attachments"
        />
      </BaseFormField>
    </BaseFormSection>

    <BaseFormSection title="Паспорт">
      <BaseFormField label="Серия паспорта:" for-id="passport_series">
        <base-input
          id="passport_series"
          type="text"
          v-model="localFormData.driver_passport.series"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Номер паспорта:" for-id="passport_number">
        <base-input
          id="passport_number"
          type="text"
          v-model="localFormData.driver_passport.number"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Код подразделения:" for-id="passport_issuer_code">
        <base-input
          id="passport_issuer_code"
          type="text"
          v-model="localFormData.driver_passport.issuer_code"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Фамилия в паспорте:" for-id="passport_last_name">
        <base-input
          id="passport_last_name"
          type="text"
          v-model="localFormData.driver_passport.last_name"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Имя в паспорте:" for-id="passport_first_name">
        <base-input
          id="passport_first_name"
          type="text"
          v-model="localFormData.driver_passport.first_name"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Отчество в паспорте:" for-id="passport_middle_name">
        <base-input
          id="passport_middle_name"
          type="text"
          v-model="localFormData.driver_passport.middle_name"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Кем выдан:" for-id="passport_issued_by">
        <base-input
          id="passport_issued_by"
          type="text"
          v-model="localFormData.driver_passport.issued_by"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Дата выдачи:" for-id="passport_issued_at">
        <base-input
          id="passport_issued_at"
          type="date"
          v-model="localFormData.driver_passport.issued_at"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Дата рождения:" for-id="passport_birth_date">
        <base-input
          id="passport_birth_date"
          type="date"
          v-model="localFormData.driver_passport.birth_date"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Место рождения:" for-id="passport_birth_place">
        <base-input
          id="passport_birth_place"
          type="text"
          v-model="localFormData.driver_passport.birth_place"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Адрес регистрации:" for-id="passport_registration_address">
        <base-input
          id="passport_registration_address"
          type="text"
          v-model="localFormData.driver_passport.registration_address"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Пол:" for-id="passport_gender">
        <base-select
          id="passport_gender"
          v-model="localFormData.driver_passport.gender"
          :options="genderOptions"
          placeholder="Выберите пол"
          clearable
        />
      </BaseFormField>

      <BaseFormField label="Гражданство:" for-id="passport_citizenship">
        <base-input
          id="passport_citizenship"
          type="text"
          v-model="localFormData.driver_passport.citizenship"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField label="Сканы паспорта:" for-id="passport_attachments" wide>
        <AttachmentUploader
          v-model:attachment-ids="localFormData.driver_passport.attachment_ids"
          attachable-type="DriverPassport"
          compact
          requisite-code="driver-passport"
          :form-id="formId"
          :existing-attachments="localFormData.driver_passport.attachments"
        />
      </BaseFormField>
    </BaseFormSection>
  </div>
</template>

<script>
import AttachmentUploader from "@/components/Attachment/Uploader.vue";
import DriverLicenseCategories from "@/components/Driver/DriverLicenseCategories.vue";
import { normalizeDriverLicenseFormData } from "@/utils/driverLicenseUtils";
import { normalizeDriverPassportFormData } from "@/utils/driverPassportUtils";

export default {
  name: "DriverCreateForm",
  components: { AttachmentUploader, DriverLicenseCategories },
  props: {
    formData: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => ({
        last_name: false,
        first_name: false,
      }),
    },
    formId: {
      type: String,
      default: "",
    },
  },

  emits: ["update:form-data", "clear-error"],

  data() {
    return {
      localFormData: this.normalizeFormData(this.formData),
      genderOptions: [
        { value: "male", label: "Мужской" },
        { value: "female", label: "Женский" },
      ],
    };
  },

  watch: {
    localFormData: {
      handler(newVal) {
        this.$emit("update:form-data", newVal);
      },
      deep: true,
    },

    formData: {
      handler(newVal) {
        const normalizedFormData = this.normalizeFormData(newVal);
        if (this.isSameFormData(normalizedFormData, this.localFormData)) {
          return;
        }

        Object.assign(this.localFormData, normalizedFormData);
      },
      deep: true,
    },
  },

  methods: {
    normalizeFormData(formData) {
      return {
        ...formData,
        driver_license: normalizeDriverLicenseFormData(formData.driver_license),
        driver_passport: normalizeDriverPassportFormData(formData.driver_passport),
      };
    },

    validate() {
      return true;
    },

    currentFormData() {
      return this.normalizeFormData(this.localFormData);
    },

    isFieldFilled(field) {
      return Boolean(String(this.localFormData[field] || "").trim());
    },

    isSameFormData(left, right) {
      return JSON.stringify(left) === JSON.stringify(right);
    },

  },
};
</script>
